import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-history-layout',
  templateUrl: './payment-history-layout.component.html',
  styleUrls: ['./payment-history-layout.component.scss']
})
export class PaymentHistoryLayoutComponent {

}
